import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FortNoxAuthService {
  constructor(@Inject(HttpClient) private http: HttpClient) {}

  save(params: any, body: any): Observable<any> {
    // Matches FortNoxAuth.save from restServices.js
    // POST to api/authcode
    return this.http.post('api/authcode', body);
  }
}
